<div *ngIf="!framed" class="splash-card-header w-100 text-center">
    <img class="splash-card-header-logo" src="/assets/form_q_logo.png" />
    <div class="splash-card-header-title">Authenticating...</div>
</div>
<q-auth-frame [framed]="framed"></q-auth-frame>
